import React from "react";
import "./ResetPasswordSuccess.scss";

function ResetPasswordSuccess() {
  return (
    <div className="reset-password-success">
      <div className="message">
        Success! Hang tight - we&#39;re just logging you in. You&#39;ll use your new password from here on out.
      </div>
    </div>
  );
}

export default ResetPasswordSuccess;
